<div class="youtube-preview-holder" *ngIf="item && item.snippet">
  <div class=" youtube-image-icon">
    <img [src]="item.snippet.thumbnails.medium.url|safe"/>
  </div>
  <div class="youtube-details">
    <div class="youtube-video-title" [innerHTML]="item.snippet.title"></div>
    <div class="youtube-channel-title">{{item.snippet.channelTitle}}</div>
    <div class="youtube-video-description">{{item.snippet.description}}</div>
  </div>
</div>
